import DateTime from '../dateTime/DateTime';
Date.prototype.add = function (duration) {
    return new DateTime(this).add(duration).toDate();
};
Date.prototype.addDays = function (days) {
    return new DateTime(this).addDays(days).toDate();
};
Date.prototype.addHouse = function (hours) {
    return new DateTime(this).addHouse(hours).toDate();
};
Date.prototype.addMilliseconds = function (milliseconds) {
    return new DateTime(this).addMilliseconds(milliseconds).toDate();
};
Date.prototype.addMinutes = function (minutes) {
    return new DateTime(this).addMinutes(minutes).toDate();
};
Date.prototype.addMonths = function (months) {
    return new DateTime(this).addMonths(months).toDate();
};
Date.prototype.addSeconds = function (seconds) {
    return new DateTime(this).addSeconds(seconds).toDate();
};
Date.prototype.addWeeks = function (weeks) {
    return new DateTime(this).addWeeks(weeks).toDate();
};
Date.prototype.addYears = function (years) {
    return new DateTime(this).addYears(years).toDate();
};
Date.prototype.clone = function () {
    return new DateTime(this).toDate();
};
Date.prototype.diff = function (other) {
    return new DateTime(this).diff(new DateTime(other));
};
Date.prototype.equals = function (other) {
    return DateTime.equal(this, other);
};
Date.prototype.format = function (format) {
    return new DateTime(this).format(format);
};
Date.prototype.isGreaterThan = function (other) {
    return DateTime.compare(this, other) === 1;
};
Date.prototype.isGreaterThanOrEqualTo = function (other) {
    return DateTime.compare(this, other) >= 1;
};
Date.prototype.isLessThan = function (other) {
    return DateTime.compare(this, other) === -1;
};
Date.prototype.isLessThanOrEqualTo = function (other) {
    return DateTime.compare(this, other) <= -1;
};
Date.prototype.isLocal = function () {
    return new DateTime(this).isLocal();
};
Date.prototype.isUTC = function () {
    return new DateTime(this).isUTC();
};
Date.prototype.startOf = function (timeUnit) {
    return new DateTime(this).startOf(timeUnit).toDate();
};
Date.prototype.subtract = function (duration) {
    return new DateTime(this).subtract(duration).toDate();
};
Date.prototype.toDateTime = function () {
    return new DateTime(this);
};
Date.prototype.toLocal = function () {
    return new DateTime(this).toLocal().toDate();
};
Date.prototype.toLongDate = function () {
    return new DateTime(this).toLongDate();
};
Date.prototype.toLongDateTime = function () {
    return new DateTime(this).toLongDateTime();
};
Date.prototype.toLongTime = function () {
    return new DateTime(this).toLongTime();
};
Date.prototype.toLongYearlessDate = function () {
    return new DateTime(this).toLongYearlessDate();
};
Date.prototype.toShortDate = function () {
    return new DateTime(this).toShortDate();
};
Date.prototype.toShortDateTime = function () {
    return new DateTime(this).toShortDateTime();
};
Date.prototype.toShortTime = function () {
    return new DateTime(this).toShortTime();
};
Date.prototype.toUnixTimestamp = function () {
    return new DateTime(this).toUnixTimestamp();
};
Date.prototype.toUTC = function () {
    return new DateTime(this).toUTC().toDate();
};
Date.prototype.truncateDays = function () {
    return new DateTime(this).truncateDays().toDate();
};
Date.prototype.truncateHours = function () {
    return new DateTime(this).truncateHours().toDate();
};
Date.prototype.truncateMilliseconds = function () {
    return new DateTime(this).truncateMilliseconds().toDate();
};
Date.prototype.truncateMinutes = function () {
    return new DateTime(this).truncateMinutes().toDate();
};
Date.prototype.truncateMonths = function () {
    return new DateTime(this).truncateMonths().toDate();
};
Date.prototype.truncateSeconds = function () {
    return new DateTime(this).truncateSeconds().toDate();
};
Date.prototype.withDay = function (value) {
    return new DateTime(this).withDay(value).toDate();
};
Date.prototype.withHour = function (value) {
    return new DateTime(this).withHour(value).toDate();
};
Date.prototype.withMillisecond = function (value) {
    return new DateTime(this).withMillisecond(value).toDate();
};
Date.prototype.withMinute = function (value) {
    return new DateTime(this).withMinute(value).toDate();
};
Date.prototype.withMonth = function (value) {
    return new DateTime(this).withMonth(value).toDate();
};
Date.prototype.withSecond = function (value) {
    return new DateTime(this).withSecond(value).toDate();
};
Date.prototype.withUTCOffset = function (value) {
    return new DateTime(this).withUTCOffset(value).toDate();
};
Date.prototype.withWeekday = function (value) {
    return new DateTime(this).withWeekday(value).toDate();
};
Date.prototype.withYear = function (value) {
    return new DateTime(this).withYear(value).toDate();
};
Date.DAYS_PER_MONTH = DateTime.DAYS_PER_MONTH;
Date.DAYS_PER_WEEK = DateTime.DAYS_PER_WEEK;
Date.DAYS_PER_YEAR = DateTime.DAYS_PER_YEAR;
Date.MINUTES_PER_HOUR = DateTime.MINUTES_PER_HOUR;
Date.MONTHS_PER_YEAR = DateTime.MONTHS_PER_YEAR;
Date.WEEKS_PER_YEAR = DateTime.WEEKS_PER_YEAR;
Date.compare = DateTime.compare;
Date.equal = DateTime.equal;
Date.isDate = DateTime.isDate;
Date.monthIndexes = DateTime.monthIndexes;
Date.monthNumbers = DateTime.monthNumbers;
Date.parseEx = function (value) {
    return DateTime.parse(value).toDate();
};
Date.tryParse = function (value, valueOnFailure) {
    var _a;
    return (_a = DateTime.tryParse(value, valueOnFailure)) === null || _a === void 0 ? void 0 : _a.toDate();
};
Date.getMonthName = DateTime.getMonthName;
Date.getMonthRange = DateTime.getMonthRange;
Date.getShortMonthName = DateTime.getShortMonthName;
Date.isMonthInRange = DateTime.isMonthInRange;
Date.weekIndexes = DateTime.weekIndexes;
//# sourceMappingURL=DateExtensions.js.map